import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client.js';
import type { SecretsResponse } from './types.js';

export function useSecrets() {
  return useQuery({
    queryKey: ['secrets'],
    queryFn: () => apiFetch<SecretsResponse>('/admin/secrets'),
  });
}

export function useSetSecret() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { key: string; value: string }) =>
      apiFetch<{ ok: true }>(`/admin/secrets/${input.key}`, {
        method: 'PUT',
        body: { value: input.value },
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['secrets'] }),
  });
}

export function useClearSecret() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (key: string) =>
      apiFetch<{ ok: true }>(`/admin/secrets/${key}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['secrets'] }),
  });
}
